import type { ReactNode } from 'react';

import { ParrotLogo } from '@experimental-components/IconsComponents/ParrotLogo';
import { WizardBackground } from '@onboarding/presentation/components/WizardBackground';

type WizardContainerProps = {
  children: ReactNode;
  topBar?: ReactNode;
};

/**
 * Split layout for the onboarding wizard.
 * Left panel (320px on lg+): background image with gradient overlay and Parrot logo.
 * Right panel: optional top bar (lg+ only) + scrollable wizard content.
 */
export const WizardContainer = ({ children, topBar }: WizardContainerProps) => {
  return (
    <div className="flex h-full w-full">
      {/* Left panel — background image + gradient + logo */}
      <div className="relative hidden w-[320px] shrink-0 flex-col justify-end overflow-hidden p-8 lg:flex">
        <WizardBackground />
        <div className="absolute inset-0 bg-linear-to-b from-transparent from-36% to-black" />
        <ParrotLogo className="relative h-16" />
      </div>

      {/* Right panel — optional top bar (lg+) + scrollable content */}
      <div className="relative flex min-h-0 flex-1 flex-col bg-muted lg:bg-background">
        {topBar && <div className="shrink-0">{topBar}</div>}
        <div className="flex flex-1 flex-col overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};
